import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const AddCollectionAccModalUI = ({
  context, successMsg, errorList, setErrorList,
  // modes
  submitted, createMode,
  // event handlers
  onSubmit, onCancelClick,
  //
  collectionAccHolderName, onCollectionAccHolderNameChange, collectionAccHolderNameError, setCollectionAccHolderNameError,
  collectionAccBankName, onCollectionAccBankNameChange, collectionAccBankNameError, setCollectionAccBankNameError,
  collectionAccNumber, onCollectionAccNumberChange, collectionAccNumberError, setCollectionAccNumberError,
  ifscCode, onIfscCodeChange, ifscCodeError, setIfscCodeError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Add Collection Account'
    buttonLabel='Add'
    cancelLabel='Cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='collectionAccHolderName' label='Collection Account Holder Name'
      required={true} maxLength={100} autoFocus={true}
      value={collectionAccHolderName} onChange={onCollectionAccHolderNameChange}
      error={collectionAccHolderNameError} setError={setCollectionAccHolderNameError}
    />
    <InputTextSF type='text' name='collectionAccBankName' label='Collection Account Bank Name'
      required={true} maxLength={100}
      value={collectionAccBankName} onChange={onCollectionAccBankNameChange}
      error={collectionAccBankNameError} setError={setCollectionAccBankNameError}
    />
    <InputTextSF type='text' name='collectionAccNumber' label='Collection Account Number'
      required={true} maxLength={100}
      value={collectionAccNumber} onChange={onCollectionAccNumberChange}
      error={collectionAccNumberError} setError={setCollectionAccNumberError}
    />
    <InputTextSF type='text' name='ifscCode' label='IFSC Code'
      required={true} maxLength={20}
      value={ifscCode} onChange={onIfscCodeChange}
      error={ifscCodeError} setError={setIfscCodeError}
    />
  </ModalFormUI>

export default AddCollectionAccModalUI